module.exports = __webpack_public_path__ + "static/media/ask.3c11a217.svg";